export const FOLLOWING_PICKS_TAB = 'FOLLOWING_PICKS_TAB';
export const FAVORITE_PICKS_TAB = 'FAVORITE_PICKS_TAB';
export const SET_ACTIVE_PICKS_TAB = 'SET_ACTIVE_PICKS_TAB';

export const setActivePicksTab = tab => ({
  type: SET_ACTIVE_PICKS_TAB,
  payload: tab,
});
